import { PATH_DELIMITER, PASSWORD_RESET_PATH } from '../../../constant/Constant';
import { createAction, handleActions } from 'redux-actions';
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { request } from '../../ApiModule';

const ACTION_PASSWORD_RESET = PASSWORD_RESET_PATH + PATH_DELIMITER + 'ACTION_PASSWORD_RESET';
const HANDLE_PASSWORD_RESET = PASSWORD_RESET_PATH + PATH_DELIMITER + 'HANDLE_PASSWORD_RESET';

export const actionPasswordReset = createAction(ACTION_PASSWORD_RESET);

export function* passwordResetSagas() {
    yield takeEvery(ACTION_PASSWORD_RESET, actionPasswordResetSaga);
}

function* actionPasswordResetSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/users/${data.userId}/reset-password`,
        data,
        callback,
    });
}

const initialState = {
    result: 0,
};

const module = handleActions(
    {
        [HANDLE_PASSWORD_RESET]: (state, { payload: result }) => ({ ...state, ...result }),
    },
    initialState,
);

export default module;
